import React, { memo, useCallback } from 'react';
import { DropdownCalendar } from '@cognitiv/cyprus-ui';
import classNames from 'classnames';
import { AdvancedFilterCalendarProps } from 'ducks/types/prop-types';
import { useFilterContext } from 'modals/advanced-filtering/context/FilterContext';
import { getTimeZone } from 'utils/time-zone';

import cn from 'modals/advanced-filtering/components/AdvancedFilter.module.scss';

const AdvancedFilterCalendarBase = ({ onDropDownChange, onParseDate }: AdvancedFilterCalendarProps) => {
  const {
    form: { start_date, finish_date },
    is_nullable_finish_date,
    is_nullable_start_date,
  } = useFilterContext();

  const handleStartDateSelect = useCallback(
    (date: { selected_date: string }) => onParseDate('start_date', date.selected_date),
    [onParseDate],
  );

  const handleEndDateSelect = useCallback(
    (date: { selected_date: string }) => onParseDate('finish_date', date.selected_date),
    [onParseDate],
  );

  return (
    <div onClick={() => onDropDownChange(true)} className={cn.dropdownCalendarWrapper}>
      <div className={classNames(cn.defaultSvg, { [cn.svg]: is_nullable_start_date })}>
        <DropdownCalendar
          label={`Start Date (${getTimeZone()})`}
          max_date={finish_date}
          onSelect={handleStartDateSelect}
          calendar_time
          selected_date={start_date}
          margin="27px 0px 0px 0px"
          position="right"
          text_align="left"
          nullable
        />
      </div>
      <div className={classNames(cn.defaultSvg, { [cn.svg]: is_nullable_finish_date })}>
        <DropdownCalendar
          label={`Finish Date (${getTimeZone()})`}
          min_date={start_date}
          onSelect={handleEndDateSelect}
          margin="27px 0px 0px 0px"
          calendar_time
          selected_date={finish_date}
          position="right"
          text_align="left"
          nullable
        />
      </div>
    </div>
  );
};

export const AdvancedFilterCalendar = memo(AdvancedFilterCalendarBase);
